import {
  FilterDocumentDateFilterTypes,
  GoalGroupBy,
  GoalSortingMode,
  GoalType,
  GroupByMode,
  SortingMode,
} from '@griply/types';

export const dateFilterTypeTranslationKeys: Record<
  FilterDocumentDateFilterTypes,
  string
> = {
  [FilterDocumentDateFilterTypes.Today]: 'general.filters.date.today',
  [FilterDocumentDateFilterTypes.ThisWeek]: 'general.filters.date.this-week',
  [FilterDocumentDateFilterTypes.NextWeek]: 'general.filters.date.next-week',
  [FilterDocumentDateFilterTypes.ThisMonth]: 'general.filters.date.this-month',
  [FilterDocumentDateFilterTypes.NextMonth]: 'general.filters.date.next-month',
  [FilterDocumentDateFilterTypes.ThisQuarter]:
    'general.filters.date.this-quarter',
  [FilterDocumentDateFilterTypes.NextQuarter]:
    'general.filters.date.next-quarter',
  [FilterDocumentDateFilterTypes.ThisYear]: 'general.filters.date.this-year',
  [FilterDocumentDateFilterTypes.NextYear]: 'general.filters.date.next-year',
  [FilterDocumentDateFilterTypes.Overdue]: 'general.filters.date.overdue',
  [FilterDocumentDateFilterTypes.Next14Days]:
    'general.filters.date.next-14-days',
  [FilterDocumentDateFilterTypes.Custom]: 'general.filters.date.custom',
  [FilterDocumentDateFilterTypes.NoDeadline]: 'general.filters.date.no-date',
  [FilterDocumentDateFilterTypes.HasDeadline]: 'general.filters.date.has-date',
};

export const goalTypeTranslationKeys: Record<GoalType, string> = {
  [GoalType.Goal]: 'context-menus.filtering.goal.filters.type.options.goals',
  [GoalType.Project]:
    'context-menus.filtering.goal.filters.type.options.projects',
};

export const groupByModeTranslationKeys: Partial<Record<GroupByMode, string>> =
  {
    [GroupByMode.None]: 'general.group-by-mode.none',
    [GroupByMode.Goal]: 'general.group-by-mode.goal',
    [GroupByMode.LifeArea]: 'general.group-by-mode.life-area',
    [GroupByMode.Priority]: 'general.group-by-mode.priority',
    [GroupByMode.Type]: 'general.group-by-mode.type',
    [GroupByMode.DayPart]: 'general.group-by-mode.time-of-day',
    [GroupByMode.StartDate]: 'general.group-by-mode.start-date',
    [GroupByMode.Deadline]: 'general.group-by-mode.deadline',
    [GroupByMode.DeadlineDeadline]: 'general.group-by-mode.deadline-deadline',
    [GroupByMode.Tag]: 'general.group-by-mode.tag',
    [GroupByMode.Section]: 'general.group-by-mode.section',
  };

export const sortingModeTranslationKeys: Partial<Record<SortingMode, string>> =
  {
    [SortingMode.Custom]: 'general.sorting-mode.custom',
    [SortingMode.DueDate]: 'general.sorting-mode.due-date',
    [SortingMode.Priority]: 'general.sorting-mode.priority',
    [SortingMode.DeadlineDeadline]: 'general.sorting-mode.deadline-deadline',
    [SortingMode.CreatedAt]: 'general.sorting-mode.created-at',
    [SortingMode.Name]: 'general.sorting-mode.name',
  };

export const goalSortingModeTranslationKeys: Partial<
  Record<GoalSortingMode, string>
> = {
  [GoalSortingMode.Custom]: 'general.labels.goals.sort.options.custom',
  [GoalSortingMode.StartDate]: 'general.labels.goals.sort.options.startDate',
  [GoalSortingMode.Deadline]: 'general.labels.goals.sort.options.deadline',
  [GoalSortingMode.Name]: 'general.labels.goals.sort.options.name',
  [GoalSortingMode.Progress]: 'general.labels.goals.sort.options.progress',
  [GoalSortingMode.Impact]: 'general.labels.goals.sort.options.impact',
  [GoalSortingMode.Tasks]: 'general.labels.goals.sort.options.tasks',
  [GoalSortingMode.LifeArea]: 'general.labels.goals.sort.options.lifeArea',
};

// Goal group-by labels. `GroupByMode.Deadline` is shared with tasks where it
// reads "Date" — for goals it must read "Deadline", so it points at the goal
// sort label instead of `groupByModeTranslationKeys`.
export const goalGroupByTranslationKeys: Partial<Record<GoalGroupBy, string>> =
  {
    [GroupByMode.None]: 'general.group-by-mode.none',
    [GroupByMode.LifeArea]: 'general.group-by-mode.life-area',
    [GroupByMode.Goal]: 'general.labels.projects.group.parent-goal',
    [GroupByMode.StartDate]: 'general.labels.goals.sort.options.startDate',
    [GroupByMode.Deadline]: 'general.labels.goals.sort.options.deadline',
  };
